//@ts-nocheck
/* 
 *  This file http-service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ConfigurationService } from './configuration.service';
import { SuperUserServerErrorHandlerService } from './error-handler/super-user-server-error-handler.service';

@Injectable()
export class HttpService {

  constructor(
    private _httpClient: HttpClient,
    private _serverError: SuperUserServerErrorHandlerService,
    public _config: ConfigurationService
  ) { }

  getHeaders() {
    const authlogin = JSON.parse(localStorage.getItem('authlogin'));
    const accessToken = authlogin ? authlogin.access_token : '';
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'domainCode': this._config.domainCode,
      'Authorization': 'Bearer ' + accessToken,
      'AccessMode': 'W'
    });
  }

  getHeadersUnauthorized() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'domainCode': this._config.domainCode,
      'AccessMode': 'W'
    });
  }

  getHeadersUnauthorizedWithAppId(apiKey, domainCode) {
    return new HttpHeaders({
      'domainCode': domainCode,
      'apiKey': apiKey,
      'AccessMode': 'W'
    });
  }

  getHeadersForFileUpload() {
    const authlogin = JSON.parse(localStorage.getItem('authlogin'));
    const accessToken = authlogin ? authlogin.access_token : '';
    return new HttpHeaders({
      'domainCode': this._config.domainCode,
      'Authorization': 'Bearer ' + accessToken,
      'AccessMode': 'W'
    });
  }

  public Post(url, param): Observable<any> {
    return this._httpClient.post(this._config.base_url + url, param, { headers: this.getHeaders() })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err)
        )
      );
  }

  handleServerError(err) {
    return throwError(err);
  }

  public Put(url, param): Observable<any> {
    return this._httpClient.put(this._config.base_url + url, param, { headers: this.getHeaders() })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err)
        )
      );
  }

  public PostUnAuthorize(url, param): Observable<any> {
    const headers = this.getHeadersUnauthorized();
    return this._httpClient.post(this._config.base_url + url, param, { headers: headers })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err, 'isUnauthorize')
        )
      );
  }

  public Get(url): Observable<any> {
    return this._httpClient.get(this._config.base_url + url, { headers: this.getHeaders() })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err)
        )
      );
  }


  public GetWithoutHeader(url): Observable<any> {
    return this._httpClient.get(this._config.base_url + url)
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err)
        )
      );
  }

  public Delete(url, param?): Observable<any> {
    return this._httpClient.delete(this._config.base_url + url, { headers: this.getHeaders() })
      .pipe(
        catchError(err =>
          this._serverError.handleServerError(err)
        )
      );
  }

  public PostFile(url, param): Observable<any> {
    const headers = this.getHeadersForFileUpload();
    headers.delete('Accept');
    return this._httpClient.post(this._config.base_url + url, param,
      { headers: headers })
      .pipe(catchError(err => this._serverError.handleServerError(err)));
  }

  public PostExternalFile(url, apiKey, domainCode, param): Observable<any> {
    const headers = this.getHeadersUnauthorizedWithAppId(apiKey, domainCode);
    headers.delete('Accept');
    return this._httpClient.post(this._config.base_url + url, param,
      { headers: headers })
      .pipe(catchError(err => this._serverError.handleServerError(err)));
  }

}